import styled from 'styled-components/macro'
import { ContentMatchSVG } from 'src/components/Icons/Basic'

export const ContentMatchIcon = styled(ContentMatchSVG)`
  width: 16px;
  height: 16px;
`

export const ContentSearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const ContentSearchLabel = styled.span`
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  padding-right: 8px;
  padding-left: 8px;
`
